import {
  Col, Row,
} from 'antd';

import BuyerGroupSkeleton from 'Components/common/skeleton/BuyerGroupSkeleton';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import styled from 'styled-components';
import {
  boxShadow, secondaryFont, primaryHeadingColor, maxWidth, retina, wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  background-color: rgba(255,255,255, 0.2);
  box-shadow: ${boxShadow};
  border-radius: 16px;
  padding: 36px;
  margin-top: 40px;
  @media all and (max-width: ${maxWidth}) , ${retina} { 
    padding: 15px 25px 25px 25px;
  }
  .head-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .right-area {
      display: flex;
      align-items: center;
    }
  }
  .main-message{
    color: ${primaryHeadingColor};
    font-weight:${wMBold};
    font-size:28px;
    font-family:${secondaryFont};
    margin:0;
    text-align:center;
  }
`;

const MostActiveGroupsSkeleton = function MostActiveGroupsSkeleton() {
  return (
    <Wrapper>
      <div className="head-wrapper">
        <SkeletonCustom width="340px" height="30px" margin="0px" />
      </div>
      <Row gutter={[24, 24]}>
        {[1, 2, 3, 4].map(() => (
          <Col
            lg={{ span: 6 }}
            xs={{ span: 24 }}
            sm={{ span: 12 }}
          >
            <BuyerGroupSkeleton border />
          </Col>
        ))}
      </Row>
    </Wrapper>
  );
};

export default MostActiveGroupsSkeleton;
